import { observer } from "mobx-react-lite";
import { Form, Input, Modal, Select } from "antd";
import React, { useState, useEffect } from "react";
import UserStore from "../../../../stores/Admin/UserStore";

const { Option } = Select;

export interface UserBindRoleDialogProps {
  visible: boolean;
  close: () => void;
  account: string;
}
const UserBindRoleDialog: React.FC<UserBindRoleDialogProps> = (props) => {
  useEffect(() => {
    UserStore.getUserisRole(props.account)
  }, [props.visible]);
  const [roleValue, setRoleValue] = useState<string[]>([]);
  const handleChange = (value: string | string[]) => {
    Array.isArray(value) ? setRoleValue(value) : setRoleValue(value.split(","));
  };

  const submit = () => {
    UserStore.editUserIsRole(props.account,roleValue)
    props.close()
  };
  return (
    <Modal
      title="分组管理"
      bodyStyle={{ height: "100px" }}
      visible={props.visible}
      onCancel={props.close}
      onOk={submit}
      cancelText="取消"
      okText="确认"
    >
      <Select
        mode="multiple"
        size="middle"
        placeholder="分组管理"
        key={UserStore?.userIsRoleList?.map((item) => item.roleName)[0]}
        defaultValue={UserStore?.userIsRoleList?.map((item) => item.roleName)}
        onChange={handleChange}
        style={{ width: "100%" }}
      >
        {UserStore?.roleList?.map((item) => (
          <Option key={item.name}>{item.name} </Option>
        ))}
      </Select>
    </Modal>
  );
};

export default observer(UserBindRoleDialog);
